import { useLanguage } from '../../../contexts/useLanguage';
import aicomicBg from '../../../assets/readdy/search_aicomic-hero-hk-orange-red-style-002__91c51c0c43.jpg';
import aicomicPhone from '../../../assets/readdy/2cc5d1b3b047d4594907b7553fec2396__a8112a1bea.png';

export default function Hero() {
  const { language } = useLanguage();

  const content = {
    zh: {
      badge: 'AI驱动 · 创意无限',
      title1: 'AI漫画生成器',
      title2: 'AI漫画创作新时代',
      description: '用AI的力量释放你的创造力，轻松创作精美漫画和动画短片',
      downloadOn: '下载',
      appStore: 'App Store',
      stat1: '10+',
      stat1Label: '国家地区',
      stat2: '1万+',
      stat2Label: '活跃用户',
      stat3: '10万+',
      stat3Label: '创作作品'
    },
    en: {
      badge: 'AI-Driven · Unlimited Creativity',
      title1: 'AiComic',
      title2: 'New Era of AI Comic Creation',
      description: 'Unleash your creativity with the power of AI, easily create beautiful comics and animated shorts',
      downloadOn: 'Download on the',
      appStore: 'App Store',
      stat1: '10+',
      stat1Label: 'Countries & Regions',
      stat2: '10K+',
      stat2Label: 'Active Users',
      stat3: '100K+',
      stat3Label: 'Creative Works'
    }
  };

  const t = content[language];

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${aicomicBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-white/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-white/90 backdrop-blur-sm border border-gray-200 px-6 py-3 rounded-full mb-8">
              <div className="w-2 h-2 bg-gray-900 rounded-full animate-pulse"></div>
              <span className="text-gray-700 text-sm font-light tracking-wide">{t.badge}</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              {t.title1}
              <br />
              <span className="text-gray-800">
                {t.title2}
              </span>
            </h1>

            <p className="text-xl text-gray-700 font-light mb-8 leading-relaxed">
              {t.description}
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4 mb-12">
              <a
                href="https://apps.apple.com/us/app/alcomic/id6744306216?platform=iphone"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 px-8 py-4 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-fill text-2xl"></i>
                <div className="text-left">
                  <div className="text-xs">{t.downloadOn}</div>
                  <div className="text-base font-bold">{t.appStore}</div>
                </div>
              </a>
            </div>

            <div className="flex items-center space-x-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900 mb-1">{t.stat1}</div>
                <div className="text-sm text-gray-600">{t.stat1Label}</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900 mb-1">{t.stat2}</div>
                <div className="text-sm text-gray-600">{t.stat2Label}</div>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900 mb-1">{t.stat3}</div>
                <div className="text-sm text-gray-600">{t.stat3Label}</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative w-80 h-[600px] mx-auto">
              <img
                src={aicomicPhone}
                alt="AiComic App"
                className="w-full h-full object-cover rounded-3xl shadow-2xl border-4 border-gray-200"
              />
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-gray-900 rounded-full flex items-center justify-center shadow-xl animate-bounce">
                <i className="ri-magic-line text-3xl text-white"></i>
              </div>
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-red-600 rounded-full flex items-center justify-center shadow-xl animate-pulse">
                <i className="ri-palette-line text-3xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-gray-700"></i>
      </div>
    </section>
  );
}
